// extracted by mini-css-extract-plugin
export default {"Offert":"offerts_Offert__MTEwz","content":"offerts_content__CW2Sp"};